'use client'
import { useState, useEffect } from 'react'

const DISMISSED_KEY = 'ff_beta_banner_dismissed'

export default function BetaBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(DISMISSED_KEY)) setVisible(true)
  }, [])

  if (!visible) return null

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, '1')
    setVisible(false)
  }

  return (
    <div className="relative border-b border-gray-100 bg-white">
      <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 text-xs text-gray-600">
        <span>We're live and loving feedback — bugs, ideas, anything. Good feedback gets rewarded with a free Plus upgrade. <a href="mailto:hello@fairfares.app" className="underline hover:text-gray-600 transition-colors">Say hi →</a></span>
        <button
          onClick={dismiss}
          aria-label="Dismiss beta notice"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 transition-colors p-2"
        >
          <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  )
}
